import React, {Component} from 'react';
import CBaseComponent from '@/components/CBaseComponent'
import {connect} from 'react-redux'
import Select from "./select2";
import './index.scss'
import {Descriptions, Card, Modal, Button, message, Empty} from "antd";
import {bindActionCreators, compose} from "redux";
import { withRouter} from 'react-router-dom'

import {
    collapsedToggle,
    setWindowInfo,
    setUserInfo,
    setCurrentTheme,
    setUserList,
    setLbname, setMenu
} from "../../redux/common/action";
import { selectIndex } from "@/servers/commonApi";

@CBaseComponent
class Home extends Component{
    constructor(props) {
        super(props);
        this.selectT = this.selectT.bind(this)
        this.selectdata = this.selectdata.bind(this)
    }


    state = {
        data: null,
        loading: false,
        indexdata:[],
        fileslist:[],
        newslist:[],
        title:'',
        scorestat:[],
        content:'',
        name: '',
        time:'',
        mname:'',
        pageno:1,
        pagesize: 50,
        page:{
            total: 0,
            page: 1,
            pageSize: 10
        },
        statuselect:'',
        provinceid:'',
        levelid:'',
    };


    componentWillReceiveProps(nextProps){

    }

    componentWillMount(){
        this.selectdata(true)
    }

    async selectdata(fresh){
        const params = {
            museumname:this.state.mname,
            provinceid:this.state.provinceid,
            levelid:this.state.levelid
        }
        await selectIndex(params).then(res=>{
            if (res){
                if (res.statecode === 0) {
                    const data = res.records[0].scorelist
                    this.setState({
                        page:{...this.state.page,total:data.length},
                        indexdata:data,
                        fileslist:res.records[0].filelist,
                        newslist:res.records[0].bulletinlist,
                        mname:'',
                        pageno:1,
                        pagesize: 50,
                        statuselect:res.records[0].step
                    })
                    if (fresh) {
                        this.setState({
                            scorestat:res.records[0].scorestat,
                        })
                    }
                } else {
                    message.error(res.statemessage);
                }
            }
        })
    }

    selectT(value,provinceid,levelid){
        this.setState({
            mname:value,
            levelid:levelid,
            provinceid:provinceid
        },()=>{this.selectdata(false)})
    }


    componentDidMount(){
    }

    render(){
        return (
            <main style={{textAlign:'left'}} className='containerblock'>
                <div className='contents'>
                    <div className='zhibiao'>
                        <span>当前进展：{this.state.statuselect}</span>
                    </div>
                    <div className='zhibiao' >
                        <Select data={this.state.indexdata}
                                onClick={this.selectT}
                                pagedata = {this.state.page}
                        />
                    </div>
                    <div className='zhibiao'>
                        <Descriptions title='评分统计情况' layout="vertical" bordered column={4}>
                            <Descriptions.Item label="参与评分博物馆总数">{this.state.scorestat.total}</Descriptions.Item>
                            <Descriptions.Item label="评分已完成">{this.state.scorestat.completed}</Descriptions.Item>
                            <Descriptions.Item label="评分中">{this.state.scorestat.scoring}</Descriptions.Item>
                            <Descriptions.Item label="评分未开始">{this.state.scorestat.notstarted}</Descriptions.Item>
                        </Descriptions>
                    </div>
                    <div className='system-info'>
                        <div className='system-tz'>
                            <Card title="系统公告" bordered={false} style={{ width: '100%' }}>
                                {
                                    this.state.newslist.length === 0? <Empty></Empty>:
                                        this.state.newslist.map(item=>{
                                            return <div onClick={()=>{this.showModal(item)}} className='new-block'>
                                                {
                                                    Number(item.top > 1000) ?
                                                        <span className='important'>{item.title}</span>:
                                                        <span>{item.title}</span>
                                                }
                                                <span>{item.postedtime}</span>
                                            </div>
                                        })
                                }

                            </Card>
                        </div>
                        <div className='system-file'>
                            <Card title="文件中心" bordered={false} style={{ width: '100%' }}>
                                {
                                    this.state.fileslist.length === 0? <Empty></Empty>:
                                        this.state.fileslist.map(item=>{
                                            return <div onClick={()=>{this.downloads(item)}} className='new-block'>
                                                <a href={item.fileurl} style={{color:'rgb(60, 185, 241)'}}>{item.title}</a >
                                            </div>
                                        })
                                }
                            </Card>
                        </div>
                    </div>
                </div>
                <Modal title={this.state.title}
                       visible={this.state.isModalVisible}
                       onCancel={this.handleCanceldialog}
                       centered={true}
                       footer={[
                           <Button key="submit" type="primary" onClick={this.handleCanceldialog}>
                               取消
                           </Button>
                       ]}
                >
                    <div style={{marginTop:'-10px',textAlign:'center',marginBottom:'10px'}}><span style={{marginRight:'10px'}}>{this.state.name}</span><span>{this.state.time}</span></div>
                    <div style={{whiteSpace: 'pre-wrap'}}>{this.state.content}</div>
                </Modal>
            </main>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        breadcrumbData: state.breadcrumbData,
        collapsed: state.collapsed,  // 侧边栏是否展开
        windowInfo: state.windowInfo,
        userInfo: state.userInfo,
        userList: state.userList,
        setLbname:state.setLbname
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        collapsedToggle: bindActionCreators(collapsedToggle, dispatch),
        setWindowInfo: bindActionCreators(setWindowInfo, dispatch),
        setUserInfo: bindActionCreators(setUserInfo, dispatch),
        setCurrentTheme: bindActionCreators(setCurrentTheme, dispatch),
        setUserList:bindActionCreators(setUserList,dispatch),
        setLbname:bindActionCreators(setLbname,dispatch),
        setMenu:bindActionCreators(setMenu,dispatch),
    };
};
export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(Home);
